export const isSistemaOperacionalWindows = () =>
  typeof navigator !== "undefined" && navigator.userAgent.indexOf("Windows") !== -1;
